import axios from 'axios';
import Consts from '../utils/consts';

const api = axios.create({
  baseURL: Consts.apiUrl,
});

export default api;
